import React, { useState } from 'react';
import CustomerInfo from '../smallComponent/CustomerInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useCustomers } from '../context/CustomerContext';
import API from '../../api';

export default function NewProject() {
  const { allCustomers, fetchCustomers } = useCustomers();
  const [modalId, setModalId] = useState(null);
  const [domain, setDomain] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // सिर्फ status = 1 वाले customers (done)
  const customers = allCustomers
    .filter(c => c.status === 1)
    .map(c => ({
      ...c,
      work_process_details:
        typeof c.work_process_details === 'string'
          ? JSON.parse(c.work_process_details || '[]')
          : c.work_process_details || []
    }));

  const showMessage = (msg, isError = false) => {
    if (isError) setError(msg);
    else setMessage(msg);
    setTimeout(() => {
      setMessage('');
      setError('');
    }, 3000);
  };

  const handleChangeStatus = async (id, newStatus) => {
    try {
      await API.post(`/customers/${id}/accept`, { status: newStatus });
      showMessage(`Project status updated to ${newStatus}`);
      fetchCustomers();
    } catch {
      showMessage('Failed to update project status', true);
    }
  };

  const handleAddDomain = async (e, id) => {
    e.preventDefault();
    try {
      await API.post(`/customers/${id}/add-domain`, { domain });
      setModalId(null);
      setDomain('');
      showMessage('Domain added successfully');
      fetchCustomers();
    } catch {
      showMessage('Failed to add domain', true);
    }
  };

  return (
    <div className="container mx-auto py-4 px-2">
      <h2 className="mb-4 text-2xl font-semibold">🚧 New Project List</h2>

      {message && (
        <div className="mb-4 rounded bg-green-100 border border-green-400 text-green-700 px-4 py-3" role="alert">
          {message}
        </div>
      )}
      {error && (
        <div className="mb-4 rounded bg-red-100 border border-red-400 text-red-700 px-4 py-3" role="alert">
          {error}
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded table-fixed">
          <thead className="bg-gray-800 text-white text-sm">
            <tr>
              <th className="border border-gray-300 px-3 py-2 w-10">SN</th>
              <th className="border border-gray-300 px-3 py-2">Customer Info</th>
              <th className="border border-gray-300 px-3 py-2 w-24">Quotation</th>
              <th className="border border-gray-300 px-3 py-2">Address</th>
              <th className="border border-gray-300 px-3 py-2">Work Details</th>
              <th className="border border-gray-300 px-3 py-2">Sales Team</th>
              <th className="border border-gray-300 px-3 py-2 w-24">Duration</th>
              <th className="border border-gray-300 px-3 py-2 w-24">Price</th>
              <th className="border border-gray-300 px-3 py-2 w-24">Call</th>
              <th className="border border-gray-300 px-3 py-2 w-40">Action</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {customers.length > 0 ? (
              customers.map((c, i) => (
                <tr key={c.id} className="even:bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2 text-center">{i + 1}</td>
                  <td className="border border-gray-300 px-3 py-2">
                    <CustomerInfo customer={c} />
                  </td>
                  <td className="border border-gray-300 px-3 py-2 text-center">
                    {c.upload_quatation ? (
                      <a
                        href={c.upload_quatation}
                        className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded"
                        download
                      >
                        📄 Download
                      </a>
                    ) : (
                      <span className="text-gray-500 italic">No File</span>
                    )}
                  </td>
                  <td className="border border-gray-300 px-3 py-2">{c.address}</td>
                  <td className="border border-gray-300 px-3 py-2">{c.work_details}</td>
                  <td className="border border-gray-300 px-3 py-2">
                    {c.salesman_name || <em className="text-gray-500">No salesman assigned</em>}
                  </td>
                  <td className="border border-gray-300 px-3 py-2 text-center">{c.project_duration} Days</td>
                  <td className="border border-gray-300 px-3 py-2 text-center">Rs.{c.price}/-</td>
                  <td className="border border-gray-300 px-3 py-2 text-center">
                    {c.contact_number ? (
                      <div className="flex justify-center space-x-2">
                        <a href={`tel:${c.contact_number}`} className="inline-flex items-center justify-center p-1 rounded text-white bg-green-600 hover:bg-green-700">
                          <FontAwesomeIcon icon={faPhone} />
                        </a>
                        <a
                          href={`https://wa.me/${c.contact_number}`}
                          target="_blank"
                          rel="noreferrer"
                          className="inline-flex items-center justify-center p-1 rounded text-white bg-green-600 hover:bg-green-700"
                        >
                          <FontAwesomeIcon icon={faWhatsapp} />
                        </a>
                      </div>
                    ) : (
                      <span className="text-gray-500 italic">No Contact</span>
                    )}
                  </td>
                  <td className="border border-gray-300 px-3 py-2 space-x-2 text-center">
                    <button
                      onClick={() => handleChangeStatus(c.id, 2)}
                      className="inline-block px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                    >
                      ✅ Accept
                    </button>
                    <button
                      onClick={() => setModalId(c.id)}
                      className="inline-block px-3 py-1 bg-yellow-400 hover:bg-yellow-500 text-black rounded text-sm"
                    >
                      ➕ Add Domain
                    </button>

                    {/* Modal */}
                    {modalId === c.id && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white rounded-lg max-w-md w-full p-6">
                          <div className="flex justify-between items-center mb-4">
                            <h5 className="text-lg font-semibold">Add Domain for {c.customer_name}</h5>
                            <button
                              onClick={() => setModalId(null)}
                              className="text-gray-600 hover:text-gray-900 font-bold text-xl"
                              aria-label="Close modal"
                            >
                              &times;
                            </button>
                          </div>
                          <form onSubmit={(e) => handleAddDomain(e, c.id)}>
                            <label className="block mb-2 font-medium" htmlFor="domainInput">
                              Domain Name
                            </label>
                            <input
                              id="domainInput"
                              type="text"
                              value={domain}
                              onChange={(e) => setDomain(e.target.value)}
                              placeholder="e.g. example.com"
                              required
                              className="w-full px-3 py-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <div className="flex justify-end space-x-2">
                              <button
                                type="button"
                                onClick={() => setModalId(null)}
                                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                              >
                                Close
                              </button>
                              <button
                                type="submit"
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                              >
                                Save Domain
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center py-4 text-gray-500">
                  No customers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
